var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ico_interfaz_nav_check_activo_relleno",
    "data-name": "Ico_interfaz_nav check activo_relleno",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.515,
    height: 29.667,
    viewBox: "0 0 30.515 29.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75923",
    "data-name": "Trazado 75923",
    d: "M14.833,0h.848a14.833,14.833,0,1,1,0,29.667h-.848A14.833,14.833,0,0,1,14.833,0Z",
    fill: "#7eccc9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cheque_6_",
    "data-name": "cheque (6)",
    transform: "translate(7.228 9.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75896",
    "data-name": "Trazado 75896",
    d: "M14.672,57.77,6.7,65.743a1.513,1.513,0,0,1-2.139,0L.443,61.627a1.513,1.513,0,0,1,2.139-2.139l3.047,3.047,6.9-6.9a1.513,1.513,0,0,1,2.139,2.139Z",
    transform: "translate(0 -55.188)",
    fill: "#fff8fb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.2aef9e7efe9af2c131a9deb20ef0be3c.svg";
export { ForwardRef as ReactComponent };